import { useNavigate, Link } from 'react-router-dom';

const Footer = function () {
    const navigate = useNavigate();

    return (
        <footer>
            <div className="content">
                <div className='company-name text-sm separator-bottom pb-4 mb-4'>
                    <p><strong>Crescento Consultoria Estratégica</strong></p>
                    <p>São Paulo - SP</p>
                    <p>CNPJ 28.670.855/0001-49</p>
                </div>
                <div className='flex flex-row gap-x-4 links separator-bottom mb-4 pb-4'>
                    <a href="#">Ir para o topo</a>
                    <Link to="/privacy">Política de Privacidade</Link>
                </div>
                <div className='disclaimer'>
                    <p>
                        As condições mencionadas podem variar de acordo com o perfil do solicitante e estão sujeitas à avaliação de terceiros.
                    </p>
                    <p>
                        O conteúdo deste site não constitui aconselhamento financeiro, jurídico ou profissional. Recomendamos que o usuário consulte um especialista qualificado antes de tomar qualquer decisão financeira. A empresa não se responsabiliza por decisões tomadas com base nas informações aqui apresentadas. Os resultados podem variar.
                    </p>
                    <p>
                        Este site pode receber remuneração por indicações de produtos ou serviços financeiros.
                    </p>
                </div>
            </div>
        </footer >
    );
}

export default Footer;